window.addEventListener("DOMContentLoaded", function() {
  customElements.define(
    "vega-lite",
    class extends HTMLElement {
      constructor() {
        super();
        this._config = {};
      }
      get config() {
        return this._config;
      }
      set config(newConfig) {
        if (this._config !== newConfig) {
          this._config = newConfig;
          window.vegaEmbed(this, this._config, { actions: false });
        }
      }
      connectedCallback() {
        window.vegaEmbed(this, this._config, { actions: false });
        this._upgradeProperty("config");
      }
      _upgradeProperty(prop) {
        if (Object.prototype.hasOwnProperty.call(this, prop)) {
          let value = this[prop];
          delete this[prop];
          this[prop] = value;
        }
      }
    }
  );
});
